import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AmazingTimePickerModule } from './atp-library/atp-time-picker.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { PcgSelectComponent } from './components/pcg-select-component/select.component';

import { CollapsibleDividerComponent } from './components/collapsible-divider/collapsible-divider.component';
import { ControlGroupComponent } from './components/control-group/control-group.component';
import { ControlRefDirective } from './directives/control-ref.directive';
import { PhoneExtDirective } from './directives/masking/phone-ext.directive';
import { StepsComponent } from './components/steps/steps.component';
import { SvgModule } from './svg/svg.module';
import { ClockPickerComponent } from './components/clock-picker/clock-picker.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { DualListBoxComponent } from './components/dual-list-box/dual-list-box.component';
import { RadioButtonListComponent } from './components/radio-button-list/radio-button-list.component';
import { TouchRadioButtonListComponent } from './components/touch-radio-button-list/touch-radio-button-list.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FixedButtonsComponent } from './components/fixed-buttons/fixed-buttons.component';
import { CurrencyService } from './directives/masking/currency.service';
import { CurrencyDirective } from './directives/masking/currency.directive';
import { BackButtonDirective } from './directives/back-button/back-button.directive';
import { SubmitUrlDirective } from './directives/submit-url.directive';
import { ShowHidePasswordComponent } from './components/show-hide-password/show-hide-password.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TextEditorComponent } from './text-editor/text-editor.component';

@NgModule({
	declarations: [
		// These two are used for control validation
		ControlGroupComponent,
		ControlRefDirective,
		// This is our collapsibe divider
		CollapsibleDividerComponent,
		// Pre-defined mask directives
		PhoneExtDirective,
		// Replacement for the steps plugin
		StepsComponent,
		ClockPickerComponent,
		DateRangeComponent,
		DualListBoxComponent,
		RadioButtonListComponent,
		TouchRadioButtonListComponent,
		FileUploadComponent,
		FixedButtonsComponent,
		CurrencyDirective,
		SubmitUrlDirective,
		BackButtonDirective,
		ShowHidePasswordComponent,
		PcgSelectComponent,
		TextEditorComponent
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		SvgModule,
		NgbDatepickerModule,
		AmazingTimePickerModule,
		AngularDualListBoxModule,
		NgbPopoverModule,
		NgSelectModule,
		NgbTooltipModule,
		RouterModule,
		FontAwesomeModule,
	],
	exports: [
		// These two are used for control validation
		ControlGroupComponent,
		ControlRefDirective,
		// This is our collapsibe divider
		CollapsibleDividerComponent,
		// Pre-defined mask directives
		PhoneExtDirective,
		CurrencyDirective,
		// Replacement for the steps plugin
		StepsComponent,
		SvgModule,
		ClockPickerComponent,
		DateRangeComponent,
		DualListBoxComponent,
		RadioButtonListComponent,
		TouchRadioButtonListComponent,
		FileUploadComponent,
		FixedButtonsComponent,
		SubmitUrlDirective,
		BackButtonDirective,
		ShowHidePasswordComponent,
		FontAwesomeModule,
		PcgSelectComponent, 
		TextEditorComponent
	],
	providers: [CurrencyService]
})
export class FormElementsModule {}
